import React from 'react'
import { Button, Form } from 'semantic-ui-react'

import DateField from '../../fields/dateField'
import ItemField from '../../fields/itemField'

export default class UnavailableItemField extends React.PureComponent {
  onChange = (field, value) => {
    const { item, onChange } = this.props
    const { startedAt, endedAt, itemKey, docId } = item

    onChange({
      itemKey,
      startedAt: startedAt || Date.now(),
      endedAt: endedAt || Date.now(),
      docId,
      [field]: value,
    })

  }

  render() {
    const { item, onRemove, allItems } = this.props

    return (
      <div>
        <Form.Group widths="equal">
          <ItemField
            required
            isClearable={false}
            isMulti={false}
            items={allItems}
            itemKeys={item.itemKey || []}
            onChange={data => this.onChange('itemKey', data.value)}
          />
          <DateField
            label="Start Date"
            onChange={value => this.onChange('startedAt', value)}
            value={item.startedAt}
          />
          <DateField
            label="End Date"
            onChange={value => this.onChange('endedAt', value)}
            value={item.endedAt}
          />
          <div style={{ paddingTop: 25, marginLeft: 15 }}>
            <Button as='a' icon='trash' color="red" size="tiny" onClick={onRemove} />
          </div>
        </Form.Group>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/restaurants/forms/unavailableItemForm/unavailableItemField.js